export function buildLoginRedirectUrl(returnPath: string): string {
  if (!returnPath.startsWith("/")) {
    return "/login";
  }

  return `/login?redirect=${encodeURIComponent(returnPath)}`;
}

export function getPostLoginRedirectPath(
  search: string,
  stateFrom?: string
): string | null {
  if (stateFrom && stateFrom.startsWith("/")) {
    return stateFrom;
  }

  const redirect = new URLSearchParams(search).get("redirect");

  if (redirect && redirect.startsWith("/")) {
    return redirect;
  }

  return null;
}

export function getHttpStatus(error: unknown): number | null {
  if (!error || typeof error !== "object" || !("response" in error)) {
    return null;
  }

  const response = (error as { response?: { status?: number } }).response;

  return typeof response?.status === "number" ? response.status : null;
}

export function getApiErrorMessage(
  error: unknown,
  fallback = "Ocorreu um erro. Tente novamente."
): string {
  if (!error || typeof error !== "object" || !("response" in error)) {
    return fallback;
  }

  const data = (error as { response?: { data?: { message?: string } } })
    .response?.data;

  if (typeof data?.message === "string" && data.message.trim().length > 0) {
    return data.message;
  }

  return fallback;
}
